import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _split from 'lodash/split';
import _map from 'lodash/map';
import PropTypes from 'prop-types';
// Material UI
// Custom
import { deviceDataShape } from 'constants/PropTypesShapes';
import ConditionInputItem from 'installations/assets/scenarios/ConditionInputItem';

const ScenarioLogExecInputCondition = ({ isErrorInputCondition, execInputCondition, device }) => {
  const inputConditions = _split(execInputCondition, ';');

  return (
    <div>
      <div className="row m-0">
        <LocalizedMessage id={`info.scenarioExecInputCondition${isErrorInputCondition ? 'Error' : ''}`} />
      </div>
      <div className="row m-0">
        {_map(inputConditions, (inputCondition) => (
          <div key={inputCondition} className="col-12">
            <ConditionInputItem
              inputCondition={inputCondition}
              device={device}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

ScenarioLogExecInputCondition.propTypes = {
  isErrorInputCondition: PropTypes.bool.isRequired,
  execInputCondition: PropTypes.string.isRequired,
  device: deviceDataShape.isRequired,
};

module.exports = ScenarioLogExecInputCondition;



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/logs/ScenarioLogExecInputCondition.js